import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from 'axios'
import { API_CONSTANTS } from '../../../../../API_CONSTANTS'

export const getServices = createAsyncThunk(
  'getServices',
  async (paramsID) => {
    const response = await axios
    .get(`${API_CONSTANTS.BASEURL_3}admin/appointments/nurse/${paramsID}`, {
        headers: API_CONSTANTS.headers(),
      })
      .then((res) => res.data.response)
    return response
  }
)
export const getServicesSlice = createSlice({
  name: 'getServices',
  initialState: {
    value: {
      sharedMedicalRecord: [],
      appointmentInfo: {
        appointment_date: '',
        appointment_status: '',
        appointment_type: '',
        booked_on: '',
        charges: '',
        medium: '',
        name: '',
        profileUrl:
          'https://img.icons8.com/material/72/000000/user-male-circle--v1.png',
        relation: '',
      },
      doctorInfo: {
        email: '',
        contact: '',
        educationTitle: '',
        emergencyContact: '',
        firstName: '',
        lastName: '',
        name: '',
        pmdc: '',
        profileUrl:
          'https://img.icons8.com/material/72/000000/user-male-circle--v1.png',
        specialization: '',
        title: '',
      },
      patientInfo: {
        email: '',
        emergencyContact: '',
        dob: '',
        gender: '',
        name: '',
        phone: '',
        profileId: '',
        relation: '',
        url: 'https://img.icons8.com/material/72/000000/user-male-circle--v1.png',
        userId: '',
      },
      prescription: {
        e_prescription: [
          {
            duration: '',
            quantity: '',
            instruction: '',
            dosage_type: '',
            category: '',
            medicine_name: '',
            intake: {
              breakfast: '',
              dinner: '',
              lunch: '',
            },
          },
        ],
        prescription_url: ' ',
      },
    },
  },
  reducers: {},
  extraReducers: {
    [getServices.pending]: (state) => {
      state.loading = true
    },
    [getServices.fulfilled]: (state, { payload }) => {
      state.loading = false
      state.value = payload
    },
    [getServices.rejected]: (state) => {
      state.loading = false
    },
  },
})

export const getServicesProfileReducer = getServicesSlice.reducer
